<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="title ? '' : 'Édition du contrat'">
      <template
        v-if="title"
        slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span class="">
            Édition du contrat
          </span>
          <span class="has-text-weight-light has-text-grey">
            <router-link
              tag="span"
              class="is-paddingless has-cursor-pointer"
              :to="{'name': 'ProgramVue', params: {id: title.id}}"
              v-if="title && title.id">
              - Programme {{ title.title }}
            </router-link>
          </span>
        </h1>
      </template>
    </page-nav-bar>
    <contract-form @updateTitle="updateTitle"></contract-form>
  </div>
</template>

<script>
export default {
  name: 'ContractEdit',
  components: {
    ContractForm: () => import('@/components/contract-matrix/ContractForm')
  },
  props: {
  },
  data () {
    return {
      title: null
    }
  },
  methods: {
    updateTitle (val) {
      this.title = val
    }
  }
}
</script>
